import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/users-manager/services/user.service';
import { IUserLoginDto, UserResetPasswordWithCode } from '../../interfaces/login.interfaces';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
@UntilDestroy()
export class ResetPasswordComponent implements OnInit {

  resetPassword: UserResetPasswordWithCode = {
    requestCode: '',
    newPassword: '',
  };

  confirmPassword = '';
  passwordNotEqual = false;
  passwordChanged = false;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.resetPassword = {
        requestCode: params['code'],
        newPassword: '',
      }
    });
  }

  onSubmit() {
    if(this.resetPassword.newPassword === this.confirmPassword) {
      this.passwordNotEqual = false;
      this.userService.resetPasswordWithCode(this.resetPassword).pipe(untilDestroyed(this)).subscribe(() => {
        this.passwordChanged = true;
      });
    } else {
      this.passwordNotEqual = true;
    }
  }

}
